import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import Story from "@/pages/story/page";
import Reviews from "@/pages/reviews/page";
import ReviewDetail from "@/pages/reviews/detail/page";
import Watch from "@/pages/watch/page";
import News from "@/pages/news/page";
import About from "@/pages/about/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "story", element: <Story /> },
      { path: "reviews", element: <Reviews /> },
      { path: "reviews/detail/:id", element: <ReviewDetail /> },
      { path: "watch", element: <Watch /> },
      { path: "news", element: <News /> },
      { path: "about", element: <About /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;